module.exports = __webpack_public_path__ + "static/google-app-store-2a9a4d3e276510f66202836b9e42d3be.png";